import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../i18n";
import { extras } from "../i18n";
import { API } from "../config";

export default function History() {
  const { lang } = useLang();
  const x = extras[lang] || extras.es;
  const [content, setContent] = useState(null);
  useEffect(() => {
    axios.get(`${API}/content`).then(({ data }) => setContent(data)).catch(() => {});
  }, []);
  const ov = content?.history?.[lang];
  const h = ov && ov.title
    ? { ...x.history, ...ov, chapters: ov.chapters?.length ? ov.chapters : x.history.chapters }
    : x.history;
  const imgRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: imgRef, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section id="historia" data-testid="history-section" className="border-y-2 border-topacio-ink bg-topacio-ink text-topacio-sand overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20">
          <div className="lg:sticky lg:top-28 self-start">
            <p className="uppercase text-xs tracking-[0.25em] text-brand font-extrabold mb-4 flex items-center gap-3">
              <span className="inline-block w-10 h-0.5 bg-brand" />
              {h.eyebrow}
            </p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight font-bold uppercase leading-tight">
              {h.title}
            </h2>
            <p className="mt-5 text-zinc-400 max-w-md leading-relaxed">{h.sub}</p>
            <div ref={imgRef} className="mt-12 relative">
              <div className="border-2 border-brand rounded-xl overflow-hidden shadow-[8px_8px_0_0_#FFCC00] rotate-1">
                <div className="aspect-[4/3] overflow-hidden">
                  <motion.img
                    src="https://images.unsplash.com/photo-1592310294836-f654307931a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHx2aW50YWdlJTIwbW90b3JjeWNsZXxlbnwwfHx8fDE3ODkxMjMyNzB8MA&ixlib=rb-4.1.0&q=85"
                    alt="Moto clásica, la historia de Topacio"
                    loading="lazy"
                    style={{ y: imgY }}
                    className="w-full h-full object-cover scale-110 will-change-transform"
                  />
                </div>
              </div>
              <span className="absolute -top-5 -right-3 bg-brand text-topacio-ink border-2 border-topacio-ink shadow-[4px_4px_0_0_rgba(0,0,0,0.6)] px-5 py-2 -rotate-3 font-hand text-2xl select-none">
                {h.sticker}
              </span>
            </div>
          </div>

          <div className="space-y-14 lg:pt-24">
            {h.chapters.map((c, i) => (
              <motion.article
                key={c.n}
                data-testid={`history-chapter-${i}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                className="relative border-l-2 border-white/15 pl-8 md:pl-12"
              >
                <div className="flex items-baseline gap-5 flex-wrap">
                  <span
                    className="font-display font-black text-6xl md:text-7xl leading-none text-transparent select-none"
                    style={{ WebkitTextStroke: "2px #FFCC00" }}
                  >
                    {c.n}
                  </span>
                  <span className="badge-brutal bg-topacio-red text-white border-white/0 shadow-[3px_3px_0_0_#FFCC00]">{c.year}</span>
                </div>
                <h3 className="font-display text-xl md:text-2xl font-bold uppercase mt-5 text-white">{c.t}</h3>
                <p className="text-zinc-400 mt-3 leading-relaxed max-w-md">{c.d}</p>
              </motion.article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
